var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MainBlock"},[_c('h1',{staticClass:"mainText"},[_vm._v("Welcome to my task manager!")]),_c('router-link',{attrs:{"to":"/tasks"}},[_c('button',{staticClass:"mainBtn"},[_vm._v(" View tasks ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }